"use client";

import { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutSummary() {
  const imageRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  const {
    ref: textRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        if (rect.top < viewportHeight && rect.bottom > 0) {
          const scrollProgress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
          const offset = scrollProgress * 15;
          setParallaxOffset(offset);
        }
      }
    };
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mediaQuery.matches) {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      handleScroll();
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div ref={imageRef} className="relative" style={{
          transform: `translateY(${parallaxOffset}px)`,
          transition: "transform 0.1s linear"
        }}>
            <div className="relative rounded-lg overflow-hidden shadow-strong">
              <img src="https://pleasing-jennet.10web.cloud/wp-content/uploads/2026/01/Photoroom_20251212_174244.jpg" alt="DJI Matrice 210 drone equipped with dual cameras" className="w-full h-auto object-cover" />
            </div>
          </div>

          <div ref={textRef} className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              Precision Aerial Solutions for Central Texas & DFW
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">MT4 Drones Services delivers cutting-edge drone services using the DJI Matrice 4T, capable of simultaneous thermal and visual imaging in a single flight. Our state-of-the-art equipment ensures complete, accurate data collection.</p>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">With up to $1 million in liability insurance, access to restricted airspace at major airports and military bases, and real-time flight monitoring, we provide safer, more cost-effective aerial solutions than traditional methods.</p>
            <p className="text-muted-foreground text-lg leading-relaxed">
              From 3D modeling and digital elevation maps to thermal and near-infrared imaging, our comprehensive services boost your bottom line while reducing waste and downtime through efficient, real-time project tracking and management.
            </p>
          </div>
        </div>
      </div>
    </section>;
}